__webpack_require__.p = "/cdn-assets/shopping-ui/";